
class CartItems extends HTMLElement {
    constructor() {
        super();

        this.cartCountDown = document.getElementById(`CartCountdown-${this.dataset.section}`)
        this.giftCardElement = document.getElementById('is-a-gift')
        this.giftCardButton = document.getElementById('cart-gift-wrapping')
        this.removeButtons = document.querySelectorAll('[data-cart-remove]')
        this.toCheckoutButton = document.getElementById('cart-checkout')
        this.couponCodeInput = document.getElementById('cart-coupon-code')
        this.cartNoteInput = document.getElementById('cart-note')
        this.checkTerms = document.getElementById('cart_conditions')

        this.toCheckoutButton?.addEventListener('click', this.handleToCheckoutPage.bind(this))

        this.initToCheckoutButtonDisabling()
        this.initCartCountdown()
        if (this.giftCardElement) this.initGiftCardElement()
        this.initGiftCardManipulation()
        // this.initQuantityUpdateButtons()
  }

    initGiftCardElement() {
        const isChecked = this.giftCardButton?.dataset.isChecked
        if (isChecked === 'true') {
            const variantId = this.giftCardButton?.dataset.giftId
            const giftCardRemoveButton = document.querySelector(`[data-cart-remove-id="${variantId}"]`)
            const giftCardQuantityInput = document.querySelector(`[data-cart-quantity-id="${variantId}"]`)

            this.giftCardElement.style.display = 'none'
            giftCardRemoveButton?.addEventListener('click', () => {
                this.giftCardButton.dataset.isChecked = 'false'
            })

            giftCardQuantityInput?.addEventListener('change', (e) => {
                const value = Number(e.target.value)
                if (value  <= 0) {
                    this.giftCardButton.dataset.isChecked = 'false'
                }
            })
        } else {
          this.giftCardElement.style.display = 'flex'
        }
    }

    initGiftCardManipulation() {
        if (this.giftCardButton) {
            this.giftCardButton.removeEventListener('click', this.onAddGiftCardClick.bind(this))
            this.giftCardButton.addEventListener('click', this.onAddGiftCardClick.bind(this))
        }
    }

    onAddGiftCardClick(e) {
        e.preventDefault()
        e.stopPropagation()
        this.giftCardButton.dataset.isChecked = 'true'
    }

    initToCheckoutButtonDisabling() {
        if (this.checkTerms) {
            window.addEventListener('load', () => {
                this.toCheckoutButton.disabled = !this.checkTerms.checked
            })
        }
    }

    initQuantityUpdateButtons() {
        this.querySelectorAll('.btn-quantity').forEach(button => {
            button.removeEventListener('click', this.onButtonClick.bind(this))
            button.addEventListener('click', this.onButtonClick.bind(this))
        })
    }

    onButtonClick(event) {
        event.preventDefault();
        const inputElement = event.target.parentElement.querySelector('.quantity');
        const value = Number(inputElement.value);
        let newVal
        if (event.target.classList.contains('plus')) {
            newVal = value + 1;
        } else {
            newVal = value - 1;
        }

        if (newVal >= 0) {
            const changeEvent = new Event('change', { bubbles: true })

            inputElement.value = newVal;
            inputElement.dispatchEvent(changeEvent);
        } 
    }

    async handleToCheckoutPage(e) {
        e.preventDefault()

        try {
            // saving coupon
            const couponCode = this.couponCodeInput?.value 
            if (couponCode) {
                localStorage.setItem('storedDiscount', couponCode)
                const couponRes =  await fetch(`/discount/${couponCode}`)
                const text1 = await couponRes.text()
            }
            
            // saving cart note
            const cartNote = this.cartNoteInput?.value
            if (cartNote) {
                const cartNoteBody = JSON.stringify({ note: cartNote })
                const cartNoteRes = await fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body: cartNoteBody }})
                const text2 = await cartNoteRes.text()
            }

        } catch(error) {
            console.error(`Error: ${error.message}`)
        }

        let checkoutHref = this.toCheckoutButton.dataset.href;
        if (checkoutHref == null) {
            checkoutHref = `${window.routes?.root ? window.routes.root : ""}/checkout`;
        }
        
        window.location = checkoutHref;
    }

    initCartCountdown(){
        if(!this.cartCountDown) return;

        if(!this.cartCountDown.classList.contains('is-running')){
            const duration = this.cartCountDown.getAttribute('data-cart-countdown') * 60
            const element = this.cartCountDown.querySelector('.time');

            this.cartCountDown.classList.add('is-running');
            this.startTimerCartCountdown(duration, element);
        }
    }

    startTimerCartCountdown(duration, element){
        var timer = duration, minutes, seconds, text;

        var startCoundown = setInterval(() => {
            minutes = parseInt(timer / 60, 10);
            seconds = parseInt(timer % 60, 10);

            minutes = minutes < 10 ? "0" + minutes : minutes;
            seconds = seconds < 10 ? "0" + seconds : seconds;
            text = minutes + ":" + seconds;

            element.innerText = text;

            if (--timer < 0) {
                clearInterval(startCoundown);
                this.cartCountDown.remove();
            }
        }, 1000);
    }
}

customElements.define('cart-items', CartItems);

class Accordion extends HTMLElement {
    constructor() {
        super();
        this.header = this.firstElementChild;
        this.content = this.lastElementChild;

        this.header.addEventListener('click', this.onSummaryClick.bind(this));
    }

    onSummaryClick(event) {
        event.preventDefault();
        this.hasAttribute('open') ? this.close() : this.open(event);
    }

    open(event) {
        this.setAttribute('open', true);
        this.setAttribute('aria-expanded', 'true');
        this.content.setAttribute('aria-hidden', 'false');
        $(this.content).slideDown()
    }

    close() {
        this.removeAttribute('open');
        this.setAttribute('aria-expanded', 'false');
        this.content.setAttribute('aria-hidden', 'true');
        $(this.content).slideUp()
    }
}

customElements.define('accordion-block', Accordion);

// jayesh

/**
 * ELLA THEME - COMPLETE CART UPDATE WITH TOTALS FIX
 * Updates quantity, line items, AND cart totals
 */

if (!customElements.get('cart-update-quantity')) {
  customElements.define('cart-update-quantity', class CartUpdateQuantity extends HTMLElement {
    constructor() {
      super();
      
      // Get elements
      this.input = this.querySelector('input[data-cart-quantity]');
      this.plusBtn = this.querySelector('[data-plus-quantity-cart]');
      this.minusBtn = this.querySelector('[data-minus-quantity-cart]');
      
      if (!this.input) {
        console.error('Cart quantity input not found');
        return;
      }
      
      // Bind events
      this.plusBtn?.addEventListener('click', this.handlePlus.bind(this));
      this.minusBtn?.addEventListener('click', this.handleMinus.bind(this));
      this.input.addEventListener('change', this.handleInputChange.bind(this));
      this.input.addEventListener('blur', this.handleInputChange.bind(this));
      
      // Debounce timer
      this.debounceTimer = null;
    }

    handlePlus(e) {
      e.preventDefault();
      const currentValue = parseInt(this.input.value) || 0;
      const maxQty = this.input.dataset.inventoryQuantity 
        ? parseInt(this.input.dataset.inventoryQuantity) 
        : 999;
      
      if (currentValue < maxQty) {
        this.input.value = currentValue + 1;
        this.updateCart();
      }
    }

    handleMinus(e) {
      e.preventDefault();
      const currentValue = parseInt(this.input.value) || 0;
      
      if (currentValue > 1) {
        this.input.value = currentValue - 1;
        this.updateCart();
      } else if (currentValue === 1) {
        // Ask for confirmation before removing
        if (confirm('Remove this item from cart?')) {
          this.input.value = 0;
          this.updateCart();
        }
      }
    }

    handleInputChange(e) {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => {
        const value = parseInt(this.input.value) || 0;
        
        // Validate quantity
        if (value < 0) {
          this.input.value = 0;
        }
        
        const maxQty = this.input.dataset.inventoryQuantity 
          ? parseInt(this.input.dataset.inventoryQuantity) 
          : 999;
        
        if (value > maxQty) {
          this.input.value = maxQty;
          alert(`Only ${maxQty} items available in stock`);
        }
        
        this.updateCart();
      }, 500);
    }

    updateCart() {
      const line = this.input.dataset.line;
      const quantity = parseInt(this.input.value) || 0;
      
      if (!line) {
        console.error('No line key found');
        return;
      }

      // Show loading state
      this.classList.add('cart-updating');
      this.input.disabled = true;
      if (this.plusBtn) this.plusBtn.style.pointerEvents = 'none';
      if (this.minusBtn) this.minusBtn.style.pointerEvents = 'none';

      // Prepare request body
      const body = {
        id: line,
        quantity: quantity
      };

      // Call Shopify Cart API
      fetch(window.Shopify?.routes?.root + 'cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(body)
      })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(cart => {
        console.log('Cart updated:', cart);
        this.handleSuccess(cart, quantity);
      })
      .catch(error => {
        console.error('Cart update failed:', error);
        this.handleError(error);
      })
      .finally(() => {
        this.classList.remove('cart-updating');
        this.input.disabled = false;
        if (this.plusBtn) this.plusBtn.style.pointerEvents = '';
        if (this.minusBtn) this.minusBtn.style.pointerEvents = '';
      });
    }

    handleSuccess(cart, newQuantity) {
      if (newQuantity === 0) {
        // Item removed - reload page
        window.location.reload();
        return;
      }

      // Find the updated item in cart response
      const lineIndex = parseInt(this.input.dataset.index) - 1;
      const updatedItem = cart.items[lineIndex];

      if (!updatedItem) {
        console.warn('Updated item not found in cart response');
        window.location.reload();
        return;
      }

      // 1. Update line item total
      this.updateLineTotal(updatedItem);

      // 2. Update cart totals (CRITICAL FIX)
      this.updateCartTotals(cart);

      // 3. Update cart count
      this.updateCartCount(cart.item_count);

      // 4. Trigger custom event
      document.dispatchEvent(new CustomEvent('cart:updated', {
        detail: { cart: cart, item: updatedItem }
      }));
    }

    updateLineTotal(item) {
      const lineIndex = this.input.dataset.index;
      const totalBlock = document.querySelector(`[data-line-item-total="${lineIndex}"]`);
      
      if (!totalBlock) {
        // Fallback: find by closest parent
        const cartItemRow = this.closest('.cart-item, [data-cart-item]');
        if (cartItemRow) {
          const priceDisplay = cartItemRow.querySelector('[data-item-price-with-quantity-display]');
          if (priceDisplay) {
            const priceToDisplay = item.final_price !== item.original_price 
              ? item.final_price 
              : item.original_price;
            const lineTotal = priceToDisplay * item.quantity;
            priceDisplay.textContent = this.formatMoney(lineTotal);
          }
        }
        return;
      }

      // Calculate display price
      const priceToDisplay = item.final_price !== item.original_price 
        ? item.final_price 
        : item.original_price;
      
      const lineTotal = priceToDisplay * item.quantity;

      // Update data attributes
      totalBlock.dataset.price = priceToDisplay;
      totalBlock.dataset.originalPrice = item.original_price;

      // Update displayed price
      const priceDisplay = totalBlock.querySelector('[data-item-price-with-quantity-display]');
      if (priceDisplay) {
        priceDisplay.textContent = this.formatMoney(lineTotal);
      }
    }

    updateCartTotals(cart) {
      console.log('Updating cart totals:', cart);

      // ============================================
      // 1. UPDATE SUBTOTAL (cart.original_total_price)
      // ============================================
      const subtotalElement = document.querySelector('.cart-total-subtotal .cart-total-value .text');
      if (subtotalElement) {
        subtotalElement.textContent = this.formatMoney(cart.original_total_price);
        console.log('✅ Subtotal updated:', cart.original_total_price);
      } else {
        console.warn('⚠️ Subtotal element not found');
      }

      // ============================================
      // 2. UPDATE GRAND TOTAL (cart.total_price)
      // ============================================
      const grandTotalElement = document.querySelector('.cart-total-grandtotal .cart-total-value .text');
      const grandTotalContainer = document.querySelector('.cart-total-grandtotal .cart-total-value[data-cart-total-value]');
      
      if (grandTotalElement) {
        grandTotalElement.textContent = this.formatMoney(cart.total_price);
        console.log('✅ Grand total updated:', cart.total_price);
      }
      
      if (grandTotalContainer) {
        grandTotalContainer.setAttribute('data-cart-total-value', cart.total_price);
      }

      // ============================================
      // 3. UPDATE DISCOUNT / SAVINGS
      // ============================================
      const discountRow = document.querySelector('.cart-total-savings[data-saved-discount-display]');
      const discountValueElement = document.querySelector('[data-saved-discount-value]');
      
      if (discountRow && discountValueElement) {
        if (cart.total_discount > 0) {
          // Show discount row
          discountRow.style.display = '';
          discountRow.setAttribute('data-dis', cart.total_discount);
          
          // Build discount display
          let discountHTML = '';
          
          if (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length > 0) {
            // Show named discounts
            cart.cart_level_discount_applications.forEach(discount => {
              discountHTML += `
                <svg class="icon icon-discount" width="12" height="12" viewBox="0 0 12 12">
                  <path d="M6 0L7.5 4.5L12 6L7.5 7.5L6 12L4.5 7.5L0 6L4.5 4.5L6 0Z" fill="currentColor"/>
                </svg>
                ${discount.title} (-${this.formatMoney(discount.total_allocated_amount)})
              `;
            });
            discountValueElement.innerHTML = discountHTML;
          } else {
            // Show total discount amount
            discountValueElement.textContent = '-' + this.formatMoney(cart.total_discount);
          }
          
          console.log('✅ Discount updated:', cart.total_discount);
        } else {
          // Hide discount row
          discountRow.style.display = 'none';
          console.log('✅ Discount hidden (no discount)');
        }
      }

      // ============================================
      // 4. UPDATE FREE SHIPPING BAR (if exists)
      // ============================================
      this.updateFreeShippingBar(cart);
    }

    updateCartCount(count) {
      const countElements = document.querySelectorAll('[data-cart-count], .cart-count-bubble, .cart-count, .header-cart-count, .cart-link__bubble span');
      countElements.forEach(el => {
        el.textContent = count;
        el.classList.toggle('hidden', count === 0);
      });
      console.log('✅ Cart count updated:', count);
    }

    updateFreeShippingBar(cart) {
      const freeShippingBar = document.querySelector('[data-free-shipping-bar]');
      if (!freeShippingBar) return;

      const threshold = parseInt(freeShippingBar.dataset.threshold) || 30000; // ₹300 default
      const remaining = Math.max(0, threshold - cart.total_price);
      const percentage = Math.min((cart.total_price / threshold) * 100, 100);

      const progressBar = freeShippingBar.querySelector('[data-progress], .progress-bar');
      if (progressBar) {
        progressBar.style.width = `${percentage}%`;
      }

      const messageEl = freeShippingBar.querySelector('[data-message], .free-shipping-message');
      if (messageEl) {
        if (remaining > 0) {
          messageEl.textContent = `Only ${this.formatMoney(remaining)} away from Free Shipping`;
        } else {
          messageEl.textContent = 'You qualify for Free Shipping! 🎉';
        }
      }
      
      console.log('✅ Free shipping bar updated');
    }

    handleError(error) {
      alert('Unable to update cart. Please try again.');
      // Reload page as fallback
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    }

    formatMoney(cents) {
      if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
        return Shopify.formatMoney(cents, window.theme?.moneyFormat || '₹{{amount}}');
      }
      
      // Fallback formatter for Indian Rupees
      const amount = (cents / 100).toFixed(2);
      return `₹${amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
    }
  });
}

// ============================================
// ENSURE SHOPIFY ROUTES EXIST
// ============================================

document.addEventListener('DOMContentLoaded', function() {
  if (typeof window.Shopify === 'undefined') {
    window.Shopify = {};
  }
  
  if (!window.Shopify.routes) {
    window.Shopify.routes = { root: '/' };
  }

  console.log('✅ Cart update quantity system with totals fix loaded');
});




